import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UserPlus, LogIn } from "lucide-react";

interface AuthPromptDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
}

const AuthPromptDialog = ({
  open,
  onOpenChange,
  title = "Join SkillSwipe",
  description = "Sign up or log in to connect with learners and start swapping skills!",
}: AuthPromptDialogProps) => {
  const navigate = useNavigate();

  const handleAuth = (mode: "signup" | "login") => {
    onOpenChange(false);
    navigate("/auth", { state: { mode } });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl">{title}</DialogTitle>
          <DialogDescription className="text-center">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-3 mt-4">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => handleAuth("login")}
          >
            <LogIn className="mr-2 h-4 w-4" />
            Log In
          </Button>
          <Button
            variant="gradient"
            className="flex-1"
            onClick={() => handleAuth("signup")}
          >
            <UserPlus className="mr-2 h-4 w-4" />
            Sign Up
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AuthPromptDialog;
